<template>
    <div style="position: relative;">
        <b-overlay :show="loading" no-wrap></b-overlay>
        <b-card>
            <div id="zones-map" ref="map"></div>
        </b-card>
	</div>
</template>

<script>
export default {
    props: {
        traceInfo: {
            default() {
                return {ratePlanId: -1}
            }
        }
    },
    data() {
		return {
			loading: false,
			map: null,
            drawed:[],
		};
	},
    methods: {
        generarNuevoColor() {
            var simbolos, color;
            simbolos = "0123456789ABCDEF";
            color    = "#";

            for(var i = 0; i < 6; i++){
                color = color + simbolos[Math.floor(Math.random() * 16)];
            }
            return color;
        },
		setZonesByGeopoints(zones) {
            //limiamos los polygonos dibujados
            if(this.drawed.length>0){
                this.drawed.forEach((polygon)=>{
                    polygon.setMap(null)
                })
            }
            var bounds = new window.google.maps.LatLngBounds();
            zones.forEach((item) => {
                let gPolygonCoords = []
                item.zoneGeoPoints.forEach(element => {
                    let item = {lat:parseFloat(element.latitude),lng:parseFloat(element.longitude)}
                    gPolygonCoords.push(item)
                    //Para ajustar el mapa
                    var _point = new window.google.maps.LatLng(item.lat, item.lng)
                    bounds.extend(_point);
                });
                
                let gPolygon = new window.google.maps.Polygon({
                    paths: gPolygonCoords,
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: this.generarNuevoColor(),
                    fillOpacity: 0.5,
                });
                
                gPolygon.setMap(this.map);
                this.drawed.push(gPolygon) 

                var infoWindow = new window.google.maps.InfoWindow();
                window.google.maps.event.addListener(gPolygon, 'click', function (e) {
                    infoWindow.setContent(item.name);
                    infoWindow.setPosition(e.latLng);
                    infoWindow.open(this.map);
                });
            });


            this.map.fitBounds(bounds);// se ajusta el mapa para mostrar los poligonos
        },
		initMap() {
			this.map = new window.google.maps.Map(this.$refs["map"], {
				center: { lat: 21.063954981427, lng:  -86.889645168215 },
				zoom: 11,
				streetViewControl: false
			});
		},
        async drawPolygonsByTraceData(){
            let trace = this.traceInfo;
            let ratePlanModel = trace.ratePlanModel;
            let zones         = ratePlanModel.zonedArea.zones;
            if(ratePlanModel.supplierId>0){
                zones         = ratePlanModel.supplierZonedArea.zones;
            }
            this.setZonesByGeopoints(zones)
            this.createMarkFromPlaces([trace.pickupPlace,trace.dropoffPlace])
            
        },
        createMarkFromPlaces(arrayPlaces){
            var bounds = new window.google.maps.LatLngBounds();
            arrayPlaces.forEach((place,index)=>{
                let point = (index==0)?"A":"B";
                var myLatlng = new window.google.maps.LatLng(parseFloat(place.latitude), parseFloat(place.longitude));
                new window.google.maps.Marker({
                    position: myLatlng,
                    map: this.map,
                    label: point,
                    title:place.name
                })
                var _point = new window.google.maps.LatLng(parseFloat(place.latitude), parseFloat(place.longitude))
                bounds.extend(_point);
                
            })
            setTimeout(() => {
                this.map.fitBounds(bounds);
            }, 0);
            
        },
         createMarks(marks){
            let template = {"latitude":null,"longitude":null,"content":"not assigned","label":"P"}
            var bounds = new window.google.maps.LatLngBounds();
            marks.forEach((markItem)=>{
                let markDetail = {...template,...markItem}
                let point = markDetail.label;
                var myLatlng = new window.google.maps.LatLng(parseFloat(markDetail.latitude), parseFloat(markDetail.longitude));
                var mark = new window.google.maps.Marker({
                    position: myLatlng,
                    map: this.map,
                    label: point,
                    title: ""
                })
                var _point = new window.google.maps.LatLng(parseFloat(markDetail.latitude), parseFloat(markDetail.longitude))
                bounds.extend(_point);

                var infoWindow = new window.google.maps.InfoWindow();
                window.google.maps.event.addListener(mark, 'click', function (e) {
                    infoWindow.setContent(markDetail.content);
                    infoWindow.setPosition(e.latLng);
                    infoWindow.open(this.map);
                });
                
            })
            setTimeout(() => {
                this.map.fitBounds(bounds);
            }, 0);   
        }
	},
    mounted() {
		this.initMap();
        if(this.traceInfo.ratePlanId>0){
            setTimeout(() => {
                this.drawPolygonsByTraceData();
            }, 0);
        }
        this.$emit('mounted')
	}
}
</script>
<style scoped>

    #zones-map {
        width: 100%;
        height: 300px;
    }

    #zoned-rate-editor .card-body{
        color:black !important
    }

</style>